import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, filter, map, of, switchMap } from 'rxjs';
import { FetchAllUsersIfNeeded } from '../users-state/users-state.action';
import { UsersState } from '../users-state/users-state.state';

@Pipe({
  name: 'userName',
  standalone: false,
})
export class UserNamePipe implements PipeTransform {
  private readonly store = inject(Store);

  transform(
    userId: string | undefined | null,
    emptyStringOnError = false,
    lastNameFirst = false,
  ): Observable<string> {
    if (!userId) {
      return of(this.handleError(emptyStringOnError));
    }
    return this.store.dispatch(new FetchAllUsersIfNeeded()).pipe(
      switchMap(() => this.store.select(UsersState.isUsersStateInitialized)),
      filter((isInitialized) => isInitialized === true),
      switchMap(() => this.store.select(UsersState.userById(userId))),
      map((user) =>
        user
          ? lastNameFirst
            ? `${user.lastName}, ${user.firstName}`
            : `${user.firstName} ${user.lastName}`
          : this.handleError(emptyStringOnError),
      ),
    );
  }

  private handleError(emptyStringOnError: boolean): string {
    if (emptyStringOnError) {
      return '';
    } else {
      return 'n/a';
    }
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [UserNamePipe],
  exports: [UserNamePipe],
})
export class UserNamePipeModule {}
